export const ROLE_OPTIONS = ["admin", "dispatcher", "driver"];

export const BOOKING_STATUS_OPTIONS = [
  "new",
  "quoted",
  "confirmed",
  "assigned",
  "ongoing",
  "completed",
  "cancelled",
];

export const BOOKING_STATUS_LABELS = {
  new: "New",
  quoted: "Quoted",
  confirmed: "Confirmed",
  assigned: "Assigned",
  ongoing: "Ongoing",
  completed: "Completed",
  cancelled: "Cancelled",
};

export const SERVICE_TYPE_OPTIONS = ["dropoff", "hourly"];

export const SERVICE_TYPE_LABELS = {
  dropoff: "Drop off",
  hourly: "Hourly Booking",
};

export const VEHICLE_STATUS_OPTIONS = ["active", "maintenance", "inactive"];
export const VEHICLE_AVAILABILITY_OPTIONS = ["available", "assigned", "unavailable"];

export const DRIVER_STATUS_OPTIONS = ["active", "inactive", "on_leave"];
export const DRIVER_AVAILABILITY_OPTIONS = ["available", "assigned", "off_duty", "unavailable"];

export const PAYMENT_STATUS_OPTIONS = ["pending", "partial", "paid"];
export const PAYMENT_METHOD_OPTIONS = ["cash", "bank_transfer", "card", "corporate_invoice"];

export const EXPENSE_TYPE_OPTIONS = ["fuel", "toll", "parking", "driver_allowance", "other"];

export const STATUS_TONE_MAP = {
  new: "bg-sky-500/10 text-sky-400 border-sky-500/20",
  quoted: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  confirmed: "bg-blue-500/10 text-blue-400 border-blue-500/20",
  assigned: "bg-violet-500/10 text-violet-400 border-violet-500/20",
  ongoing: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  completed: "bg-green-500/10 text-green-400 border-green-500/20",
  cancelled: "bg-red-500/10 text-red-400 border-red-500/20",
  pending: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  partial: "bg-orange-500/10 text-orange-400 border-orange-500/20",
  paid: "bg-green-500/10 text-green-400 border-green-500/20",
  active: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  maintenance: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  inactive: "bg-zinc-500/10 text-zinc-400 border-zinc-500/20",
  on_leave: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  available: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  unavailable: "bg-red-500/10 text-red-400 border-red-500/20",
  assigned: "bg-blue-500/10 text-blue-400 border-blue-500/20",
  off_duty: "bg-zinc-500/10 text-zinc-400 border-zinc-500/20",
};

export const OPS_ACTIVE_STATUSES = ["confirmed", "assigned", "ongoing"];
